// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__bot63","signatureButtonsRight":"ModalSign_signatureButtonsRight__2oixd"};